import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { _Col2Id, _GetCustomAttributesForComponent, } from "@discovery/sonic-api-ng-optics";
import { Lens } from "@discovery/prelude/lib/control/lens";
import { RailTypes } from "../rails";
import { _superStarImageMobile, _RailsData, _RailsTitle, _SuperStarImageDesktop, } from "./optics";
import { useAds } from "../../utils/hooks/useAds";
const customAttrValidator = optional(record({
    viewAllRoute: string,
}));
const SuperStarHeroImageView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const superstarDataM = Fold.preview(_superStarImageMobile, data);
    const _superStarImageDesktopM = Fold.preview(_SuperStarImageDesktop, data);
    const desktopImage = M.fromMaybe(_superStarImageDesktopM, {
        alias: M.of("buddy-valastro-banner"),
        height: 1620,
        title: M.of(""),
        description: M.of(""),
        default: M.of(false),
        kind: "default",
        src: "",
        width: 2880,
        cropCenter: { _tag: "None" },
    });
    const _RailsDataM = Fold.toArray(_RailsData, data);
    const titleM = Fold.preview(Fold.compose(_RailsTitle, M._Just()), data);
    const cards = _RailsDataM;
    const title = M.fromMaybe(titleM, "");
    const contentGridIdM = Fold.preview(_Col2Id, data);
    const gridID = M.fromMaybe(contentGridIdM, "");
    const viewAllRouteM = Fold.preview(Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("viewAllRoute")), data);
    return {
        superstarDataM,
        desktopImage,
        title,
        cards,
        gridID,
        viewAllRouteM,
    };
};
const HeroSuperstar = ({ superstarDataM, desktopImage, title, cards, gridID, viewAllRouteM, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const { adsHasValidPackage, enableAds } = useAds();
    const webAuthRedirectionUrl = environment.authService.protocol + "://" + environment.authService.domain;
    const railType = RailTypes.Basic;
    // CONFIG
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    const isAdsEnabled = enableAds && !adsHasValidPackage;
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(SuperStarHeroImageView, { superstarDataM: superstarDataM, title: title, cards: cards, railType: railType, read: environment, viewAllRouteM: viewAllRouteM, desktopImage: desktopImage, webAuthRedirectionUrl: webAuthRedirectionUrl, gridID: gridID, ageConstraint: ageConstraint, isAdsEnabled: isAdsEnabled })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, HeroSuperstar);

